export default __webpack_public_path__ + "static/media/carbon_map.6ad297aa.svg";